import { useEffect, useState } from "react";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { httpClient } from "../../../util/Api";
import { useHistory } from "react-router-dom";
import UsersAPI from "../../../services/Users/Users";
import LoginAPI from "../../../services/Login/Login";
import { getUserData, removeUserData } from "../../../appRedux/actions/Admin";
import { setCookie, getCookie, removeCookie } from "../../../helpers/Cookie";

const UsersApi = new UsersAPI();
const LoginApi = new LoginAPI();

export const useProvideAuth = () => {
  const history = useHistory();
  const [authUser, setAuthUser] = useState(null);
  const [error, setError] = useState("");
  const [isLoadingUser, setLoadingUser] = useState(true);
  const [isLoading, setLoading] = useState(false);

  const fetchStart = () => {
    setLoading(true);
    setError("");
  };

  const fetchSuccess = () => {
    setLoading(false);
    setError("");
  };

  const fetchError = (error) => {
    setLoading(false);
    setError(error);
  };

  const dispatch = useDispatch();

  // User login
  const userLogin = async (user) => {
    try {
      fetchStart();
      let userPayload = user;
      userPayload.role = "admin";
      userPayload.createdDttm = new Date().getTime();

      const response = await LoginApi.getLoginApi(userPayload);
      if (response.data?.isLogin) {
        fetchSuccess();
        httpClient.defaults.headers.common["Authorization"] =
          "Bearer " + response.data.token;
        setCookie("token", response.data.token);
        setCookie("refreshToken", response.data.refreshToken);
        getAuthUser(response.data);
        history.push("/dashboard/crm");
      } else {
        fetchError(error);
        message.error("Email or password is incorrect.");
      }
    } catch (error) {
      if (error.response.status === 429) {
        message.error(error.response.data);
      } else {
        fetchError(error.message);
      }
    }
  };

  // const userLogin = (user, callbackFun) => {
  //   fetchStart();
  //   let userPayload = user;
  //   userPayload.role = "admin";
  //   userPayload.createdDttm = new Date().getTime();
  //   httpClient
  //     .post("/users/login", userPayload)
  //     .then(({ data }) => {
  //       if (data.isLogin) {
  //         fetchSuccess();
  //         httpClient.defaults.headers.common["Authorization"] =
  //           "Bearer " + data.token;
  //         setCookie("token", data.token);
  //         getAuthUser(data);
  //         history.push("/dashboard/crm");
  //         if (callbackFun) callbackFun();
  //       } else {
  //         fetchError(error);
  //         message.error("Email or password is incorrect.");
  //       }
  //     })
  //     .catch(function (error) {
  //       if (error.response.status === 429) {
  //         message.error(error.response.data);
  //       } else {
  //         fetchError(error.message);
  //       }
  //     });
  // };

  // const userChangePassword = (userCredentials, callbackFun) => {
  //   const token = getCookie('token');
  //   if (token) {
  //     httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  //   }

  //   const userId = authUser.id;
  //   let credentials = userCredentials;

  //   credentials.userId = userId;
  //   credentials.role = authUser.role;
  //   fetchStart();

  //   httpClient
  //     .post('/change-password', credentials)
  //     .then(({ data }) => {
  //       if (data.isChanged) {
  //         fetchSuccess();
  //         // message.success(data.message);

  //         // Display success Sweet Alert
  //         // Modal.success({
  //         //   title: 'Password Updated',
  //         //   content: 'Your password has been updated successfully.',
  //         //   onOk: () => {
  //         //     if (callbackFun) callbackFun();
  //         //   },
  //         // });
  //         message.success("Your password has been updated successfully.");
  //       } else {
  //         fetchError(data.error);
  //         // message.error(data.message);

  //         // Display error Sweet Alert
  //         Modal.error({
  //           title: data.message,
  //         });
  //       }
  //     })
  //     .catch(function (error) {
  //       if(error.response.status === 429) {
  //         message.error(error.response.data);
  //       } else {
  //         fetchError(error.message);
  //       }
  //     });
  // };

  const sendPasswordResetEmail = (email, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const confirmPasswordReset = (code, password, callbackFun) => {
    fetchStart();

    setTimeout(() => {
      fetchSuccess();
      if (callbackFun) callbackFun();
    }, 300);
  };

  const userSignOut = (callbackFun) => {
    httpClient.defaults.headers.common["Authorization"] = "";
    removeCookie("token");
    removeCookie("refreshToken");
    removeCookie("userId");
    removeCookie("authUser");
    removeCookie("clientId");
    localStorage.removeItem('cAdminClientId');
    setAuthUser(false);
    dispatch(removeUserData(""));
    // removeUserData
  };

  const getAuthUser = async (data) => {
    try {
      setCookie("userId", data.userId);
      fetchStart();

      const response = await UsersApi.getAuthUser(data.userId);
      if (response && response.data) {
        fetchSuccess();
        setCookie(
          "authUser",
          JSON.stringify(response.data).replace(/</g, "\\u003c"),
        );
        setCookie("clientId", response.data.clientId);
        setAuthUser(response.data);
      } else {
        fetchError(error);
      }
    } catch (error) {
      httpClient.defaults.headers.common["Authorization"] = "";
      fetchError(error.message);
    }

    // httpClient
    //   .get(`/pr-users/${data.userId}`)
    //   .then(({ data }) => {
    //     if (data) {
    //       fetchSuccess();
    //       setCookie('authUser', JSON.stringify(data));
    //       setCookie('clientId', data.clientId);
    //       setAuthUser(data);
    //     } else {
    //       fetchError(error);
    //     }
    //   })
    //   .catch(function (error) {
    //     httpClient.defaults.headers.common['Authorization'] = '';
    //     fetchError(error.message);
    //   });
  };

  // const getAuthUser = () => {
  //   fetchStart();
  //   httpClient
  //     .post('auth/me')
  //     .then(({ data }) => {
  //       console.log(data);
  //       console.log(data.user);
  //       if (data.user) {
  //         fetchSuccess();
  //         setAuthUser(data.user);
  //       } else {
  //         fetchError(data.error);
  //       }
  //     })
  //     .catch(function (error) {
  //       httpClient.defaults.headers.common['Authorization'] = '';
  //       fetchError(error.message);
  //     });
  // };

  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.

  const getAuthUserData = async (userId) => {
    try {
      const response = await UsersApi.getAuthUser(userId);
      if (response && response.data) {
        setAuthUser(response.data);
        //store admin user in store
        dispatch(getUserData(response.data));
      } else {
        fetchError(error);
      }
      setLoadingUser(false);
    } catch (error) {
      removeCookie("token");
      httpClient.defaults.headers.common["Authorization"] = "";
      setLoadingUser(false);
    }
  };

  useEffect(() => {
    const token = getCookie("token");
    if (token) {
      httpClient.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    const userId = getCookie("userId");
    if (userId) {
      getAuthUserData(userId);

      // httpClient
      //   .get(`/pr-users/${userId}`)
      //   .then(({ data }) => {
      //     if (data) {
      //       setAuthUser(data);
      //       //store admin user in store
      //       dispatch(getUserData(data));
      //     }
      //     setLoadingUser(false);
      //   })
      //   .catch(function () {
      //     removeCookie('token');
      //     httpClient.defaults.headers.common['Authorization'] = '';
      //     setLoadingUser(false);
      //   });
    } else {
      removeCookie("token");
      setLoadingUser(false);
    }
    //eslint-disable-next-line
  }, []);

  // Return the user object and auth methods
  return {
    isLoadingUser,
    isLoading,
    authUser,
    error,
    setError,
    setAuthUser,
    getAuthUser,
    userLogin,
    // userChangePassword,
    userSignOut,
    sendPasswordResetEmail,
    confirmPasswordReset,
  };
};
